"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveRequisitionPayloadToJSON = exports.SaveRequisitionPayloadFromJSONTyped = exports.SaveRequisitionPayloadFromJSON = exports.instanceOfSaveRequisitionPayload = void 0;
var runtime_1 = require("../runtime");
var AdeCarrierCouplesConsent_1 = require("./AdeCarrierCouplesConsent");
var AdeGene_1 = require("./AdeGene");
var AdePatchPatientDto_1 = require("./AdePatchPatientDto");
var PatchRequisitionClinicalTeamDto_1 = require("./PatchRequisitionClinicalTeamDto");
var PatchRequisitionPayloadDto_1 = require("./PatchRequisitionPayloadDto");
var ReasonsForTestingDto_1 = require("./ReasonsForTestingDto");
/**
 * Check if a given object implements the SaveRequisitionPayload interface.
 */
function instanceOfSaveRequisitionPayload(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSaveRequisitionPayload = instanceOfSaveRequisitionPayload;
function SaveRequisitionPayloadFromJSON(json) {
    return SaveRequisitionPayloadFromJSONTyped(json, false);
}
exports.SaveRequisitionPayloadFromJSON = SaveRequisitionPayloadFromJSON;
function SaveRequisitionPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'requisition': !(0, runtime_1.exists)(json, 'requisition') ? undefined : (0, PatchRequisitionPayloadDto_1.PatchRequisitionPayloadDtoFromJSON)(json['requisition']),
        'reasonsForTesting': !(0, runtime_1.exists)(json, 'reasonsForTesting') ? undefined : (0, ReasonsForTestingDto_1.ReasonsForTestingDtoFromJSON)(json['reasonsForTesting']),
        'riskData': !(0, runtime_1.exists)(json, 'riskData') ? undefined : json['riskData'],
        'patient': !(0, runtime_1.exists)(json, 'patient') ? undefined : (0, AdePatchPatientDto_1.AdePatchPatientDtoFromJSON)(json['patient']),
        'otherPatients': !(0, runtime_1.exists)(json, 'otherPatients') ? undefined : (json['otherPatients'].map(AdePatchPatientDto_1.AdePatchPatientDtoFromJSON)),
        'clinicalTeam': !(0, runtime_1.exists)(json, 'clinicalTeam') ? undefined : (0, PatchRequisitionClinicalTeamDto_1.PatchRequisitionClinicalTeamDtoFromJSON)(json['clinicalTeam']),
        'carrierCouplesConsents': !(0, runtime_1.exists)(json, 'carrierCouplesConsents') ? undefined : (json['carrierCouplesConsents'].map(AdeCarrierCouplesConsent_1.AdeCarrierCouplesConsentFromJSON)),
        'rqReviewIndicatedGenes': !(0, runtime_1.exists)(json, 'rqReviewIndicatedGenes') ? undefined : (json['rqReviewIndicatedGenes'].map(AdeGene_1.AdeGeneFromJSON)),
    };
}
exports.SaveRequisitionPayloadFromJSONTyped = SaveRequisitionPayloadFromJSONTyped;
function SaveRequisitionPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'requisition': (0, PatchRequisitionPayloadDto_1.PatchRequisitionPayloadDtoToJSON)(value.requisition),
        'reasonsForTesting': (0, ReasonsForTestingDto_1.ReasonsForTestingDtoToJSON)(value.reasonsForTesting),
        'riskData': value.riskData,
        'patient': (0, AdePatchPatientDto_1.AdePatchPatientDtoToJSON)(value.patient),
        'otherPatients': value.otherPatients === undefined ? undefined : (value.otherPatients.map(AdePatchPatientDto_1.AdePatchPatientDtoToJSON)),
        'clinicalTeam': (0, PatchRequisitionClinicalTeamDto_1.PatchRequisitionClinicalTeamDtoToJSON)(value.clinicalTeam),
        'carrierCouplesConsents': value.carrierCouplesConsents === undefined ? undefined : (value.carrierCouplesConsents.map(AdeCarrierCouplesConsent_1.AdeCarrierCouplesConsentToJSON)),
        'rqReviewIndicatedGenes': value.rqReviewIndicatedGenes === undefined ? undefined : (value.rqReviewIndicatedGenes.map(AdeGene_1.AdeGeneToJSON)),
    };
}
exports.SaveRequisitionPayloadToJSON = SaveRequisitionPayloadToJSON;
